import { css } from "@emotion/react";
import { memo } from "react";
import { tipsList } from "../../../consts";
import Tips from "../Tips";

const TipsSection = () => {
  return (
    <div
      id="tips"
      css={css`
        background-color: #d65b56;
        padding: 60px;
        @media screen and (max-width: 1024px) {
          padding: 24px;
        }
      `}
    >
      <div
        css={css`
          max-width: 860px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          flex-direction: column;
          gap: 16px;
        `}
      >
        {tipsList.map((tip, i) => (
          <Tips key={i} tip={tip} />
        ))}
      </div>
    </div>
  );
};

export default memo(TipsSection);
